import React from 'react';
import PropTypes from 'prop-types';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import imagePlaceholder from '../Sites/imagePlaceholder.png';

const SitesCardSkeletonLoader = ({
  shouldEnableAnimation = false,
  iconSize = 36,
  skeletonMainWidth = '90%',
  skeletonMainHeight = 20,
  skeletonTextWidth1 = '50%',
  skeletonTextWidth2 = '90%',
  skeletonDetailHeight = 16,
  skeletonDetailWidth1 = '60%',
  skeletonDetailWidth2 = '40%',
}) => {
  return (
    <div className="relative bg-vamos-v-light-gray max-w-74 h-98.25 rounded-10px overflow-hidden shadow-vamos-shadow border-2">
      {/* Icon */}
      <div className="flex items-center justify-center w-9 h-9 absolute z-10 mt-3.25 ml-3.5 ">
        <Skeleton circle height={iconSize} width={iconSize} enableAnimation={shouldEnableAnimation} />
      </div>
      {/* Image */}
      <div className="h-42.75 flex justify-center">
        <img src={imagePlaceholder} alt="primary site img" className="filter grayscale" />
      </div>
      {/* Text and Details */}
      <div className="flex flex-col justify-between mt-4 mx-6 mb-6 gap-y-1">
        <div>
          <Skeleton width={skeletonMainWidth} height={skeletonMainHeight} enableAnimation={shouldEnableAnimation} />
          <div className="flex justify-between mt-2">
            <Skeleton width={skeletonTextWidth1} height={skeletonDetailHeight} containerClassName="flex-1" enableAnimation={shouldEnableAnimation} />
            <Skeleton width={skeletonTextWidth2} height={skeletonDetailHeight} containerClassName="flex-1" enableAnimation={shouldEnableAnimation} />
          </div>
        </div>
        <Skeleton count={2} height={skeletonDetailHeight} width="100%" enableAnimation={shouldEnableAnimation} />
        <div className="flex flex-col gap-y-1">
          <div className="flex flex-row justify-between">
            <Skeleton height={skeletonDetailHeight} width={skeletonDetailWidth1} containerClassName="flex-1" enableAnimation={shouldEnableAnimation} />
            <Skeleton height={skeletonDetailHeight} width={skeletonDetailWidth2} containerClassName="flex-1" enableAnimation={shouldEnableAnimation} />
          </div>
          <div className="flex flex-row">
            <Skeleton height={skeletonDetailHeight} width={skeletonDetailWidth1} containerClassName="flex-1" enableAnimation={shouldEnableAnimation} />
            <Skeleton height={skeletonDetailHeight} width={skeletonDetailWidth1} containerClassName="flex-1" enableAnimation={shouldEnableAnimation} />
          </div>
        </div>
      </div>
    </div>
  );
};

SitesCardSkeletonLoader.propTypes = {
  shouldEnableAnimation: PropTypes.bool,
  iconSize: PropTypes.number,
  skeletonMainWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  skeletonMainHeight: PropTypes.number,
  skeletonTextWidth1: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  skeletonTextWidth2: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  skeletonDetailHeight: PropTypes.number,
  skeletonDetailWidth1: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  skeletonDetailWidth2: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default SitesCardSkeletonLoader;
